import ReactHtmlParser from 'react-html-parser'
import { HIGHLIGHT_METRIC } from '../../../../model/caf.interface'
import useHtmlParserTransform from '../../../../modules/hooks/webview/caf/common/useHtmlParserTransform'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { IC_CAF_ALERT_TRIANGLE } from '../../../../modules/images'
import { ICON_X_CIRCLE_RED } from '../../../../modules/svg/svg'

type RenderAccordionTitlePropsType = { type: HIGHLIGHT_METRIC | ''; content; index: number; tag: string }

const AccordionTitle = ({ type, content, index, tag }: RenderAccordionTitlePropsType) => {
  const { t } = useTranslation()
  const { transformHTMLNode } = useHtmlParserTransform()

  const products = {
    [HIGHLIGHT_METRIC.REPETITION]: (
      <div className="flex w-full items-center">
        <span className="text-sTitle mr-[4px] font-bold text-purple-500">{content.repeated_word}</span>
        <span className="text-sBody text-gray-500 ">{t(n_caf.highlight.repeat(content.repeated_count))}</span>
      </div>
    ),
    [HIGHLIGHT_METRIC.GRAMMAR]: (
      <div className="flex flex-1 items-center">
        <img src={tag == '14' ? IC_CAF_ALERT_TRIANGLE : ICON_X_CIRCLE_RED} className="self-start" alt="circle" />
        <span className="ml-[10px] text-[14px] font-medium ">
          {ReactHtmlParser(content.my_sentence, {
            transform: transformHTMLNode,
          })}
        </span>
      </div>
    ),
    [HIGHLIGHT_METRIC.RUNON]: (
      <div className="flex flex-1 items-center">
        <img src={IC_CAF_ALERT_TRIANGLE} className="self-start" alt="circle" />
        <span className="ml-[10px] text-[14px] font-medium tracking-tight">
          {ReactHtmlParser(content.sentence, {
            transform: transformHTMLNode,
          })}
        </span>
      </div>
    ),
    [HIGHLIGHT_METRIC.SENTENCE_STRUCTURE]: (
      <div className="flex flex-1 items-center">
        <span className="ml-[10px] text-[14px] font-medium tracking-tight">
          {ReactHtmlParser(content.sentence, {
            transform: transformHTMLNode,
          })}
        </span>
      </div>
    ),
    [HIGHLIGHT_METRIC.SPEECH_RATE]: (
      <span className="text-sTitle mr-[4px] font-bold text-black">
        {t(n_caf.highlight.sr_section)} #{index}
      </span>
    ),
    [HIGHLIGHT_METRIC.FILLER_WORD]: (
      <span className="text-[14px] font-medium tracking-tight">
        {ReactHtmlParser(content.sentence, {
          transform: transformHTMLNode,
        })}
      </span>
    ),
    [HIGHLIGHT_METRIC.PRONUNCIATION]: (
      <div className="w-full">
        <span className="text-[16px] font-bold tracking-tight text-gray-700">
          {ReactHtmlParser(content.sentence, {
            transform: transformHTMLNode,
          })}
        </span>
        <span className="ml-[8px] text-[14px] text-gray-400">
          {!isNaN(content.error_rate) ? t(n_caf.highlight18.error_rate) + ' ' + content.error_rate * 100 + '%' : ''}
        </span>
      </div>
    ),
  }
  return products[type] ?? <>{content.repeated_word}</>
}

export default AccordionTitle
